<div class="upcoming-container" [class.clickable]="hasForthcoming">
    @if (hasForthcoming) {
        <div [class.upcoming-detail-card]="!showTable" (click)="showTableDialog()">
            @if (title) {
                <h3>{{title}} @if (showThisWeek && count > 0) {<span>{{count}}</span>}</h3>
            }
            @if (showTable) {
                <div>
                    @if (thisWeek) {
                        <app-upcoming-interviews-table [filterCountry]="filterCountry" [compact]="compact" [showInterviewer]="showInterviewer" [showTime]="showTime" [thisWeek]="thisWeek" [filter]="filter"></app-upcoming-interviews-table>
                    }
                    @if (showThisWeek && (!hasForthcoming && !hasNext)) {
                        <div class="this-week">
                            @if (title) {
                                <h3>{{title}}</h3>
                            }
                            <p>{{noInterviews}}</p>
                        </div>
                    }
                </div>
            } @else {
                @if (next) {
                    <p>Next interview {{next.date}}, {{next.hour}}</p>
                }
            }
        </div>
    }
</div>